import { createSelector } from 'reselect';
import { getRestaurantDetails, GetRestaurantProps } from './menuSelectors';
import { paymentSelectors } from '../redux/payment';

export const getPayment = paymentSelectors.getPayment;
export const getSelectedPaymentId = paymentSelectors.getSelectedPaymentId;
export const getSelectedPayment = paymentSelectors.getSelectedPayment;

/**
 * Gets available payments combining user and restaurant config
 */
export const getAvailablePayments = createSelector<
  WebOrder.State,
  GetRestaurantProps,
  WebOrder.State.Payments['items'],
  ReturnType<typeof getRestaurantDetails>,
  WebOrder.State.Payment[]
>([(state) => state.payments.items, getRestaurantDetails], (items, restaurant) => {
  if (!restaurant) {
    return [];
  }

  const { AcceptCardOrders, AcceptCashOrders } = restaurant;

  return Object.values(items)
    .filter((p) => p.status !== 'error' && p.status !== 'none')
    .filter((p) => (AcceptCashOrders ? true : p.PaymentAccountType !== 'CashPaymentAccount'))
    .filter((p) => (AcceptCardOrders ? true : p.PaymentAccountType !== 'CardPaymentAccount'))
    .sort((a, b) => a.displayOrder - b.displayOrder);
});
